__turbopack_context__.v({
  "actions": "_9XJyma_actions",
  "cell": "_9XJyma_cell",
  "container": "_9XJyma_container",
  "heading": "_9XJyma_heading",
  "link": "_9XJyma_link",
  "scrollContainer": "_9XJyma_scrollContainer",
  "table": "_9XJyma_table",
  "variant--name": "_9XJyma_variant--name",
  "variant--tags": "_9XJyma_variant--tags",
});
